import React from 'react';

import './BubbleProgressBar.scss';

interface BubbleProgressBarPropsBase {
  current: number;
  max: number;
  striped?: boolean;
  hideText?: boolean;
  linearFill?: 'ocean' | 'banana' | 'lime';
  allowOverfill?: boolean;
  active?: boolean;
}

type BubbleProgressBarProps = React.HTMLAttributes<HTMLDivElement> & BubbleProgressBarPropsBase;

export default function BubbleProgressBar(props: BubbleProgressBarProps) {
  const {
    // from component
    current,
    max,
    striped,
    hideText,
    linearFill,
    allowOverfill,
    active,
    // from element
    className: propClasses,
    ...rest
  } = props;

  const progress = Math.min(100, Math.max(0, (current / max) * 100));

  const backgroundColor =
    current === max && current === 0
      ? 'bg-smoke'
      : current < 0 || (current > max && !allowOverfill)
        ? 'bg-crimson'
        : linearFill
          ? `bg-${linearFill}`
          : progress <= 33
            ? 'bg-ocean'
            : progress <= 66
              ? 'bg-banana'
              : 'bg-lime';

  const containerClasses = [
    'bubble-progress-bar-container flex items-center space-x-2 whitespace-nowrap',
  ];
  if (propClasses) containerClasses.push(propClasses);

  const classes = ['bubble-progress-bar'];
  if (active) classes.push('bubble-progress-bar-active');

  return (
    <div {...rest} className={containerClasses.join(' ')}>
      {!hideText && (
        <span className="progress-text">
          {current} / {max}
        </span>
      )}
      <div className={classes.join(' ')}>
        <div
          className={`progress-indicator ${backgroundColor} ${striped ? 'progress-indicator-striped' : ''}`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
